export default "__VITE_ASSET__8de61ea9__"